<template lang="pug">
  div(class="documents-api-action-list")
    div(
      v-for="document in documents"
      :key="document.id"
      class="documents-list__item"
    )
      div(class="d-flex align-start")
        div(class="pt-2")
          div(
            class="documents-list__item-dot"
            :class="{ filled: isPassedDocument(document) }"
          )
        div(class="pl-6 text-left")
          div(class="text-14px light dark") {{ document.title }}
          div(
            v-if="isErrorDocument(document)"
            class="text-12px pr-2 color-error"
          ) {{ getDocumentErrorMessage(document) }}
      div(class="document-list__item-icons")
        block-documents-list-item-status-icon(
          :document="document"
          :documents-states="documentsStates"
          :statuses="statuses"
        )
</template>

<script>
import BlockDocumentsListItemStatusIcon from '~/modules/documents/components/blocks/block-documents-list-item-status-icon.vue'

export default {
  name: 'BlockDocumentsApiActionList',
  components: { BlockDocumentsListItemStatusIcon },
  props: {
    documents: {
      type: Array,
      default: () => []
    },
    documentsStates: {
      type: Object,
      default: () => ({})
    },
    statuses: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    isPassedDocument(document) {
      return this._.get(this.documentsStates[document.id], 'passed')
    },
    isErrorDocument(document) {
      return this._.get(this.documentsStates[document.id], 'status') === this.statuses.error
    },
    getDocumentErrorMessage(document) {
      return this._.get(this.documentsStates[document.id], 'error.message')
    }
  }
}
</script>

<style scoped lang="scss">
.documents-list {
  &__item {
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: 8px 0;

    &:not(:last-child) {
      margin-bottom: 4px;
    }

    &-dot {
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background: #f0f1f2;

      &.filled {
        background: #000000;
      }
    }

    &-icons {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      gap: 4px;
    }
  }
}
</style>
